import styled from "@emotion/styled";

export const ColorPickerContainer = styled.div`
  width: 600px;
  display: flex;
  align-items: center;

  & > div {
    margin: 10px;
  }
`;
